import { render, staticRenderFns } from "./LanghamForm.vue?vue&type=template&id=b115f1f4&scoped=true&"
import script from "./LanghamForm.vue?vue&type=script&lang=js&"
export * from "./LanghamForm.vue?vue&type=script&lang=js&"
import style0 from "./LanghamForm.vue?vue&type=style&index=0&id=b115f1f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b115f1f4",
  null
  
)

export default component.exports